import { TypeAnimation } from "react-type-animation";
import gif1 from "../../assets/not_found/not_found1.gif";
import gif10 from "../../assets/not_found/not_found10.gif";
import gif11 from "../../assets/not_found/not_found11.gif";
import gif12 from "../../assets/not_found/not_found12.gif";
import gif13 from "../../assets/not_found/not_found13.gif";
import gif14 from "../../assets/not_found/not_found14.gif";
import gif15 from "../../assets/not_found/not_found15.gif";
import gif16 from "../../assets/not_found/not_found16.gif";
import gif17 from "../../assets/not_found/not_found17.gif";
import gif18 from "../../assets/not_found/not_found18.gif";
import gif2 from "../../assets/not_found/not_found2.gif";
import gif3 from "../../assets/not_found/not_found3.gif";
import gif4 from "../../assets/not_found/not_found4.gif";
import gif5 from "../../assets/not_found/not_found5.gif";
import gif6 from "../../assets/not_found/not_found6.gif";
import gif7 from "../../assets/not_found/not_found7.gif";
import gif8 from "../../assets/not_found/not_found8.gif";
import gif9 from "../../assets/not_found/not_found9.gif";

const Sorries = () => {
  const gifs = [
    gif1,
    gif2,
    gif3,
    gif4,
    gif5,
    gif6,
    gif7,
    gif8,
    gif9,
    gif10,
    gif11,
    gif12,
    gif13,
    gif14,
    gif15,
    gif16,
    gif17,
    gif18,
  ];

  const randomGif = () => {
    const randomIndex = Math.floor(Math.random() * gifs.length);
    return gifs[randomIndex];
  };
  return (
    <div className="loading mt-3">
      <img src={randomGif()} style={{ maxHeight: "40vh" }} />
      <div className="loading-text">
        <TypeAnimation
          sequence={[
            // Same substring at the start will only be typed once, initially
            "Desculpe, algo deu errado... você pode\n ir tomar um café!",
            1000,
            "Desculpe, algo deu errado... você pode\n ir fechar uma pasta!",
            1000,
            "Desculpe, algo deu errado... você pode\n dar uma volta!",
            1000,
            "Desculpe, algo deu errado... você pode\n dar um nome para o MendiPet chamar!",
            1000,
            "Desculpe, algo deu errado... você pode\n ligar para Dona Rosa!",
            1000,
          ]}
          speed={60}
          style={{ whiteSpace: "pre-line" }}
          repeat={Infinity}
        />
      </div>
    </div>
  );
};

export default Sorries;
